import { useMutation } from '@tanstack/react-query'

import { disagreeToAgreementRequest } from '@src/api'
import { DefaultApiDisagreeToAgreementRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDisagreeToAgreementRequest = () => {
  const { axiosInstance } = useAxios()
  return useMutation({
    mutationFn: (params: DefaultApiDisagreeToAgreementRequestRequest) =>
      disagreeToAgreementRequest(axiosInstance, params),
  })
}
